
import React from 'react';
import { useSelector } from 'react-redux';

import {
    getCalculationOperations,
    getPricelistData,
    getUsekMezItems,
    getUsekMezAttributes
} from '../../reducers/project';

import calculateSummary from './calculateSummary';
import SummaryView from './Summary.view';

const Summary = () => {

    const calculationOperations = useSelector(state => getCalculationOperations(state.project));
    const pricelistData = useSelector(state => getPricelistData(state.project));
    const usekMezItems = useSelector(state => getUsekMezItems(state.project));
    const usekMezAttributes = useSelector(state => getUsekMezAttributes(state.project));

    const calcSummary = () => {
        return calculateSummary(usekMezItems, calculationOperations, pricelistData, usekMezAttributes);
    }

    const summary = calcSummary();

    return (
        <SummaryView
            price={summary.price}
            operationItems={summary.operationItems}
        />
    );
}

export default Summary;
